export const users = {
  title: 'Tài khoản',
  resourceName: 'Tài khoản',
  titles: {
    view: 'Chi tiết tài khoản',
    show: 'Xem tài khoản',
    edit: 'Chỉnh sửa tài khoản',
    create: 'Tạo tài khoản',
    list: 'Danh sách tài khoản',
    addQuick: 'Thêm nhanh',
  },
  name: 'Tài khoản',
  tabs: {
    profile: 'Hồ sơ cá nhân',
    password: 'Đổi mật khẩu',
    settings: 'Cài đặt',
  },
  fields: {
    firstName: 'Họ',
    lastName: 'Tên',
    email: 'Email',
    phoneNumber: 'Số điện thoại',
    address: 'Địa chỉ',
    gender: 'Giới tính',
    birthday: 'Ngày sinh',
    department: 'Phòng ban',
    position: 'Chức vụ',
    dateJoined: 'Ngày tham gia',
    username: 'Tên đăng nhập',
    avatar: 'Ảnh đại diện',
    avatarZoom: 'Phóng to / thu nhỏ',
    avatarRotate: 'Xoay ảnh',
    language: 'Ngôn ngữ',
    theme: 'Giao diện',
    timezone: 'Múi giờ',
    dateFormat: 'Định dạng ngày',
    'notifications.email': 'Thông báo qua email',
    'notifications.sms': 'Thông báo qua SMS',
    'notifications.inApp': 'Thông báo trong ứng dụng',
    id: 'ID',
    role: 'Vai trò',
    status: 'Trạng thái',
    warehouse: 'Kho',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    actions: 'Hành động',
    oldPassword: 'Mật khẩu cũ',
    newPassword: 'Mật khẩu mới',
    newPasswordRetype: 'Nhập lại mật khẩu mới',
  },
  actions: {
    saveProfile: 'Lưu hồ sơ',
    saveSettings: 'Lưu cài đặt',
    changePassword: 'Đổi mật khẩu',
    changeAvatar: 'Đổi ảnh đại diện',
    cropAvatar: 'Chỉnh ảnh đại diện',
    applyCrop: 'Dùng ảnh này',
    rotate90: 'Xoay 90°',
    exportList: 'Xuất danh sách',
    syncFromAuth: 'Kéo từ Auth',
    columnPicker: 'Chọn cột hiển thị',
  },
  messages: {
    noData: 'Không có dữ liệu',
    loadUserError: 'Không thể tải thông tin người dùng',
    totalUsers: 'Tổng: {total} người dùng',
    savedSuccess: 'Đã lưu thành công',
    saving: 'Đang lưu...',
    updateSuccess: 'Cập nhật người dùng thành công',
    createSuccess: 'Tạo người dùng thành công',
    errorGeneric: 'Có lỗi xảy ra',
    loading: 'Đang tải...',
    profileUpdateSuccess: 'Cập nhật hồ sơ thành công',
    profileUpdateError: 'Cập nhật hồ sơ thất bại',
    passwordUpdateSuccess: 'Cập nhật mật khẩu thành công',
    passwordUpdateError: 'Cập nhật mật khẩu thất bại',
    settingsUpdateSuccess: 'Cập nhật cài đặt thành công',
    settingsUpdateError: 'Cập nhật cài đặt thất bại',
    avatarUpdateSuccess: 'Cập nhật ảnh đại diện thành công',
    avatarUpdateError: 'Cập nhật ảnh đại diện thất bại',
    passwordLength: 'Mật khẩu phải có ít nhất 8 ký tự',
    passwordMatch: 'Mật khẩu nhập lại không khớp',
    changePasswordError: 'Đổi mật khẩu thất bại',
    oldPasswordIncorrect: 'Mật khẩu cũ không chính xác',
    userNotFound: 'User không tồn tại hoặc inactive',
    exportSuccess: 'Xuất danh sách người dùng thành công',
    exportFailed: 'Xuất danh sách người dùng thất bại',
    syncFromAuthRunning: 'Đang kéo nhân viên từ Auth…',
    syncFromAuthSuccess:
      'Đã kéo {tongUser} nhân viên (mới {taoMoi}, cập nhật {capNhat}), {soPhanQuyen} phân quyền.',
    syncFromAuthFailed: 'Kéo nhân viên từ Auth thất bại',
  },
  search: {
    title: 'Tên đăng nhập',
    placeholder: 'Tên đăng nhập',
  },
  filter: {
    placeholder: 'Tìm theo tên đăng nhập, họ tên...',
    advancedFilter: 'Lọc nâng cao',
    username: 'Tên đăng nhập',
    fullName: 'Họ tên',
    role: 'Vai trò',
    chucNang: 'Chức năng',
    chucNangOptions: {
      nhanVienKinhDoanh: 'Nhân viên kinh doanh',
      nhanVienKyThuat: 'Nhân viên kỹ thuật',
    },
    duAn: 'Dự án',
    chiNhanh: 'Chi nhánh',
    clearFilter: 'Xóa lọc',
    search: 'Tìm kiếm',
    all: 'Tất cả',
  },
  validation: {
    usernameRequired: 'Vui lòng nhập tên đăng nhập',
    passwordRequired: 'Vui lòng nhập mật khẩu',
    usernameFormat: 'Tên đăng nhập 3–50 ký tự, chỉ gồm chữ không dấu, số và . _ - (không khoảng trắng)',
    passwordLength: 'Mật khẩu phải có ít nhất 8 ký tự',
    passwordStrength: 'Mật khẩu phải gồm cả chữ và số',
    emailInvalid: 'Email không hợp lệ',
    phoneInvalid: 'Số điện thoại không hợp lệ',
  },
  status: {
    active: 'Hoạt động',
    inactive: 'Dừng hoạt động',
  },
  roles: {
    super_admin: 'Super admin',
    admin: 'Admin',
    manager: 'Quản lý',
    standard_user: 'Nhân viên',
    customer: 'Khách hàng',
  },
  detailTabs: {
    overview: 'Tổng quan',
    info: 'Thông tin',
    phamViXemDon: 'Phạm vi xem đơn',
    customersInCharge: 'Khách hàng phụ trách',
    orders: 'Đơn hàng',
  },
  detail: {
    basicInfo: 'Thông tin cơ bản',
    personalInfo: 'Thông tin cá nhân',
    unit: 'Đơn vị trực thuộc',
  },
  form: {
    loginInfo: 'Thông tin đăng nhập',
    personalInfo: 'Thông tin cá nhân',
    passwordLabel: 'Mật khẩu',
    usernamePlaceholder: 'Nhập tên đăng nhập',
    passwordPlaceholder: 'Nhập mật khẩu (tối thiểu 8 ký tự)',
    fullNamePlaceholder: 'Nhập họ tên',
    emailPlaceholder: 'Nhập email',
    phonePlaceholder: 'Nhập số điện thoại',
    isActiveLabel: 'Kích hoạt',
  },
  phamViXemDon: {
    title: 'Phạm vi xem đơn',
    description:
      'Mặc định mỗi nhân viên xem được toàn bộ đơn trong mảng. Chỉ thu hẹp khi chọn «Chỉ đơn của tôi» hoặc «Chọn nhân viên».',
    loadError: 'Không tải được phạm vi xem đơn.',
    loadOptsError: 'Không tải được danh sách nhân viên / khách hàng.',
    savedSuccess: 'Đã lưu phạm vi xem đơn.',
    saveError: 'Lưu phạm vi xem đơn thất bại.',
    pickUsers: 'Chọn nhân viên…',
    pickCustomers: 'Chọn khách hàng…',
    selectedCount: 'Đã chọn {count}',
    saveNguoiBan: 'Lưu',
    saveKhachHang: 'Lưu',
    nguoiBan: {
      title: 'Theo người bán',
      hint: 'Ai được xem đơn đặt hàng / hóa đơn theo người bán.',
      targets: 'Được xem đơn của',
      cheDo: {
        toanDuAn: 'Xem toàn bộ đơn trong mảng',
        toanDuAnShort: 'Toàn mảng',
        toanDuAnHint: 'Tự gồm nhân viên mới — không cần chọn lại.',
        chiMinh: 'Chỉ đơn của tôi',
        chiMinhShort: 'Chỉ tôi',
        chiMinhHint: 'Chỉ đơn mình bán và khách hàng mình phụ trách.',
        whitelist: 'Chọn nhân viên được xem đơn',
        whitelistShort: 'Chọn NV',
      },
    },
    khachHang: {
      title: 'Theo khách hàng',
      hint: 'Khách hàng được mở hóa đơn — chưa chọn thì không xem được.',
      customers: 'Khách hàng được xem',
    },
  },
  profile: {
    title: 'Thông tin cá nhân',
    subtitle: 'Cập nhật thông tin cá nhân của bạn',
    personalInfo: 'Thông tin cá nhân',
    workInfo: 'Thông tin công việc',
  },
  changePassword: {
    title: 'Đổi mật khẩu',
    subtitle: 'Cập nhật mật khẩu của bạn để bảo mật tài khoản',
    note: 'Sau khi đổi thành công, hệ thống sẽ đăng xuất. Đăng nhập lại bằng mật khẩu mới.',
  },
  settings: {
    title: 'Cài đặt',
    subtitle: 'Cập nhật cài đặt của bạn',
  },
  departments: {
    HE_THONG: 'Hệ thống',
    SALES: 'Kinh doanh',
    CUSTOMER_SERVICE: 'CSKH',
    DOCUMENTATION: 'Chứng từ',
    WAREHOUSE: 'Kho',
    ACCOUNTING: 'Kế toán',
    MANAGEMENT: 'Ban Giám đốc',
  },
  positions: {
    SYSTEM: 'Hệ thống',
    HO: 'HO',
    DIRECTOR: 'Giám đốc',
    MANAGER: 'Quản lý',
    STAFF: 'Nhân viên',
    INTERN: 'Thực tập sinh',
  },
}
